__turbopack_context__.v({
  "card": "styles-module__6iJRsa__card",
  "cardOverlay": "styles-module__6iJRsa__cardOverlay",
  "iconButton": "styles-module__6iJRsa__iconButton",
  "image": "styles-module__6iJRsa__image",
});
